import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import styles from './Loading.css';

const Loading = ({ style }) => (<div
    className={styles.loading}
    style={style}
>
    <CircularProgress />
</div>);

Loading.propTypes = {
    style: React.PropTypes.object,
};

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/Components/Loading.js
 **/